import React, { FC, useEffect, useState } from "react";
import { useGetOneByIdQuery } from "../../features/api/Api";
import { isExists } from "../../utils";
import { TextField } from "@mui/material";
import { styled } from "@mui/material/styles";

const CssTextField = styled(TextField)(({ theme }) => ({
  "& label.Mui-focused": {
    color: "#853EF8",
  },
  "& .MuiInput-underline:after": {
    borderBottomColor: "#853EF8",
  },
  "& .MuiOutlinedInput-root": {
    "& fieldset": {
      borderColor:
        theme.palette.mode === "dark" ? "rgb(204 204 204 / 45%)" : "#e5e5e5",
    },
    "&:hover fieldset": {
      borderColor: "#853EF8",
    },
    "&.Mui-focused fieldset": {
      borderColor: "#853EF8",
    },
  },
}));

interface IReadOnlyField {
  name: string;
  label: string;
  resource?: string | any;
  resourceId?: string;
  valueName: string | number;
}

const ReadOnlyField: FC<IReadOnlyField> = (props) => {
  const { name, label, resource, resourceId, valueName } = props;
  const [value, setValue] = useState<string>("");

  const { data: record }: any = useGetOneByIdQuery({
    resource: resource,
    id: resourceId,
  });

  useEffect(() => {
    if (isExists(record?.data)) {
      const value = record.data[valueName];
      if (isExists(value)) {
        setValue(value);
      }
    }
  }, [record, valueName]);

  return (
    <CssTextField
      fullWidth
      name={name}
      label={label}
      value={value}
      disabled={true}
    />
  );
};

export default ReadOnlyField;
